const bannersToCarouselItems = require('../../_utilities/banners-to-carouselitems');

const reducer = () => (state, action) => {
  switch (action.type) {
    case 'UPDATE':
      state.items = action.value;
      break;

    default:
      break;
  }
  return state;
};

window.swinger.app({
  type: 'banners',
  component: 'carousel',
  reducer: reducer(),
})
  .then((app) => {
    const createItems = (banners) => {
      const items = bannersToCarouselItems(banners, window.swinger.config.language);

      app.store.dispatch({
        type: 'UPDATE',
        value: items,
      });
    };

    const state = app.store.getState();

    createItems(state.banners);

    const baseUrl = `${window.swinger.config.apiBase}${window.swinger.config.apiRoutes.banners}`;
    const url = `${baseUrl}?position=${encodeURIComponent(state.position)}`;
    window.swinger.ajax(url)
      .then((result) => {
        createItems(result.banners);
      })
      .catch((e) => {
        if (e) {
          console.error(e);
        }
      });
  })
  .catch(console.info);



// WEBPACK FOOTER //
// ./src/widgets/banners/banners.js